import React from 'react';
import Sidebar from '../component/layout/sidebar';
import Header from '../component/layout/header';
import { useState } from 'react';
import Contentmanagementnavs from '../sections/content-mangement-navigations';



const Contentmangemnt1 = () => {

     const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return ( 
         <section className='main-dashboard-container'>            
            <Sidebar isOpen={isSidebarOpen}  /> 
            <section className='container-right-info'>
                    <section className='header-container'>
                        <Header  onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}  />
                    </section>

                <Contentmanagementnavs />



            </section>
    </section>
     );
}
 
export default Contentmangemnt1;